import { render } from "./Like.vue?vue&type=template&id=3175bb2a&scoped=true"
import script from "./Like.vue?vue&type=script&lang=ts"
export * from "./Like.vue?vue&type=script&lang=ts"

import "./Like.vue?vue&type=style&index=0&id=3175bb2a&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-3175bb2a"

export default script